import React, { Component } from 'react';

import AppBase from '../../layouts/AppBase';

let Map;

export default class Dashboard extends Component {
  state = {
    mounted: false,
  };

  componentDidMount() {
    Map = require('../../components/Map').default;

    this.setState({ mounted: true });
  }

  render() {
    const { mounted } = this.state;

    return (
      <AppBase title="Dashboard">
        {(mounted && Map) && <Map />}
      </AppBase>
    );
  }
};
